/**
 * Variant select
 */
if (!customElements.get('variant-select')) {
  class VariantSelect extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange(event) {
      const target = this.getInputForEventTarget(event.target);
      this.setCurrentVariant(event.target.value);

      publish(PUB_SUB_EVENTS.variantSelectChange, {
        data: { event, target, variant: this.currentVariant },
      });
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }

    setCurrentVariant(selectedVariantId) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return variant.id === parseInt(selectedVariantId);
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }

  customElements.define('variant-select', VariantSelect);
}

/**
 * Product gallery with slider functionality
 */
document.addEventListener('DOMContentLoaded', function() {
  const gallery = document.querySelector('product-gallery');
  
  if (!gallery) {
    console.log('No product gallery found');
    return;
  }
  
  const slides = gallery.querySelectorAll('.product-slide');
  const thumbnails = gallery.querySelectorAll('.thumbnail-item');
  const prevButton = gallery.querySelector('.slider-prev');
  const nextButton = gallery.querySelector('.slider-next');
  
  let currentSlide = 1;
  
  console.log('Product Gallery Initialized:', {
    slides: slides.length,
    thumbnails: thumbnails.length,
    prevButton: !!prevButton,
    nextButton: !!nextButton
  });
  
  if (slides.length === 0) {
    console.log('No slides found');
    return;
  }
  
  function updateSlider() {
    console.log('Updating to slide:', currentSlide);
    
    // Update slides
    slides.forEach((slide, index) => {
      if (index + 1 === currentSlide) {
        slide.classList.add('active');
        slide.style.display = 'block';
      } else {
        slide.classList.remove('active');
        slide.style.display = 'none';
      }
    });
    
    // Update thumbnails
    thumbnails.forEach((thumb, index) => {
      if (index + 1 === currentSlide) {
        thumb.classList.add('active');
      } else {
        thumb.classList.remove('active');
      }
    });
    
    // Update buttons
    if (prevButton) {
      prevButton.disabled = currentSlide === 1;
    }
    
    if (nextButton) {
      nextButton.disabled = currentSlide === slides.length;
    }
    
    // Scroll thumbnail into view
    const activeThumbnail = thumbnails[currentSlide - 1];
    if (activeThumbnail) {
      activeThumbnail.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  }
  
  function goToSlide(slideNumber) {
    if (slideNumber >= 1 && slideNumber <= slides.length) {
      currentSlide = slideNumber;
      updateSlider();
    }
  }
  
  function prevSlide() {
    if (currentSlide > 1) {
      currentSlide--;
      updateSlider();
    }
  }
  
  function nextSlide() {
    if (currentSlide < slides.length) {
      currentSlide++;
      updateSlider();
    }
  }
  
  // Previous button
  if (prevButton) {
    prevButton.addEventListener('click', function(e) {
      e.preventDefault();
      console.log('Prev button clicked');
      prevSlide();
    });
  }
  
  // Next button
  if (nextButton) {
    nextButton.addEventListener('click', function(e) {
      e.preventDefault();
      console.log('Next button clicked');
      nextSlide();
    });
  }
  
  // Thumbnails
  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener('click', function(e) {
      e.preventDefault();
      const slideIndex = index + 1;
      console.log('Thumbnail clicked:', slideIndex);
      goToSlide(slideIndex);
    });
  });
  
  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft') {
      prevSlide();
    } else if (e.key === 'ArrowRight') {
      nextSlide();
    }
  });
  
  // Initialize
  updateSlider();
  
  // Make functions available globally for variant changes
  window.productGalleryGoToSlide = goToSlide;
  window.productGallerySetActiveMedia = function(mediaId) {
    const targetSlide = Array.from(slides).find(
      slide => slide.dataset.mediaId === mediaId.toString()
    );
    
    if (targetSlide) {
      const slideIndex = Array.from(slides).indexOf(targetSlide) + 1;
      goToSlide(slideIndex);
    }
  };
});

// Keep custom element for backward compatibility but make it simpler
if (!customElements.get('product-gallery')) {
  class ProductGallery extends HTMLElement {
    constructor() {
      super();
    }
    
    setActiveMedia(mediaId) {
      if (window.productGallerySetActiveMedia) {
        window.productGallerySetActiveMedia(mediaId);
      }
    }
  }
  
  customElements.define('product-gallery', ProductGallery);
}

/**
 * Product purchase
 */
if (!customElements.get('product-purchase')) {
  class ProductPurchase extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.onVariantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.variantSelectChange,
        this.handleOptionValueChange.bind(this)
      );
    }

    handleOptionValueChange({ data: { event, target, variant } }) {
      if (!this.contains(event.target)) return;
      if (!variant) return;

      this.updateVariantId(variant.id);
      this.updateURL(this.dataset.url, target.value);
      this.updatePrice(variant);
      if (variant.featured_media && variant.featured_media.id) {
        this.updateMedia(variant.featured_media.id);
      }
    }

    updateVariantId(variantId) {
      document.querySelectorAll('[name="id"]').forEach((input) => {
        input.value = variantId;
      });
    }

    updateURL(url, variantId) {
      if (this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
    }

    updatePrice(variant) {
      const priceElement = this.querySelector('.js-bold-price');
      if (!priceElement || !variant) return;

      const price = variant.price;
      const formattedPrice = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(price / 100);

      priceElement.textContent = formattedPrice;
      const compareElement = this.querySelector('.js-kingsley-compare-price');
      if (compareElement) {
        const onSale = Number(variant.compare_at_price) > Number(variant.price);
        compareElement.hidden = !onSale;
        compareElement.querySelector('[data-compare-value]').textContent = onSale
          ? new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(variant.compare_at_price / 100)
          : '';
      }

      // Update installment form if it exists
      const installmentForm = this.querySelector('form.installment input[name="id"]');
      if (installmentForm) {
        installmentForm.value = variant.id;
        installmentForm.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    updateMedia(mediaId) {
      // Try using global function first
      if (window.productGallerySetActiveMedia) {
        window.productGallerySetActiveMedia(mediaId);
        return;
      }
      
      // Fallback to custom element method
      const productGallery = this.querySelector('product-gallery');
      if (!productGallery) return;

      if (typeof productGallery.setActiveMedia === 'function') {
        productGallery.setActiveMedia(mediaId);
      }
    }
  }

  customElements.define('product-purchase', ProductPurchase);
}
